import { useTranslation } from 'react-i18next';
import { formatMoney } from '../../lib/format';

/** Autonomy levels TWO can hold for a connection, permission or task. Not changeable from chat. */
export type AutonomyLevel = 'observe' | 'prepare' | 'ask' | 'auto';
export const AUTONOMY_LEVELS: readonly AutonomyLevel[] = ['observe', 'prepare', 'ask', 'auto'];

/**
 * Quiet secondary-text badge; deliberately no semantic colour, since autonomy is a setting,
 * not a status. Optional limit renders as currency ("up to $2,000").
 */
export function Badge({
  level,
  limit,
  currency = 'USD',
  className = '',
}: {
  level: AutonomyLevel;
  limit?: string | number | undefined;
  currency?: string;
  className?: string;
}) {
  const { t, i18n } = useTranslation();
  const locale = i18n.resolvedLanguage ?? 'en';
  const limitText =
    limit !== undefined && limit !== null && limit !== ''
      ? t('autonomy.upTo', { amount: formatMoney(String(limit), currency, locale) })
      : null;
  return (
    <span
      className={[
        'inline-flex items-center gap-1.5 rounded-full border border-line bg-canvas px-2.5 py-0.5 text-xs text-ink-2',
        className,
      ].join(' ')}
    >
      <span aria-hidden className="size-1.5 rounded-full bg-line-strong" />
      <span>{t(`autonomy.${level}`)}</span>
      {limitText ? <span className="tabular text-ink-3">· {limitText}</span> : null}
    </span>
  );
}
